import React, { useRef, useState, useEffect } from "react";
import { Button, CircularProgress, useTheme } from "@mui/material";

const CustomButton = ({
  text = "Button",
  outlined = false,
  loading = false,
  onClick,
  sx = {},
  ...props
}) => {
  const theme = useTheme();
  const [dimensions, setDimensions] = useState({
    width: "auto",
    height: "auto",
  });
  const buttonRef = useRef(null);

  useEffect(() => {
    if (buttonRef.current && !loading) {
      const { offsetWidth, offsetHeight } = buttonRef.current;
      setDimensions({ width: offsetWidth, height: offsetHeight });
    }
  }, [loading, text]);

  return (
    <Button
      ref={buttonRef}
      variant={outlined ? "outlined" : "contained"}
      onClick={onClick}
      disabled={loading}
      sx={{
        backgroundColor: outlined ? "transparent" : theme.palette.primary.main,
        color: outlined
          ? theme.palette.text.primary
          : theme.palette.primary.contrastText,
        border: outlined ? `1px solid ${theme.palette.divider}` : "none",
        borderRadius: "8px",
        padding: "10px 20px",
        textTransform: "none",
        fontWeight: 600,
        position: "relative",
        width: loading ? `${dimensions.width}px` : "auto",
        height: loading ? `${dimensions.height}px` : "auto",
        transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
        ":hover": {
          backgroundColor: outlined
            ? theme.palette.action.hover
            : theme.palette.primary.dark,
          borderColor: outlined ? theme.palette.primary.main : undefined,
        },
        ...sx,
      }}
      {...props}
    >
      {loading ? (
        <CircularProgress
          size={24}
          color="inherit"
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            marginTop: "-12px",
            marginLeft: "-12px",
          }}
        />
      ) : (
        text
      )}
    </Button>
  );
};

export default CustomButton;
